import service, { HttpResponseSuccess } from '@/services/service';
import { User } from '@/modules/user/userTypes';

const apiClient = service(`${process.env.REACT_BACKEND_HOST}`);

export interface OnboardingUserPayload {
	targetAudience: string;
	offering: string;
	valueProposition: string;
	signature: string;
}

export type OnboardingUserResponse = User;

export const ONBOARDING_USER_QUERY_KEY = ['onboardingUser'];

export const createOnboardingUser = (
	payload: OnboardingUserPayload
): Promise<HttpResponseSuccess<OnboardingUserResponse>> =>
	apiClient.post('/api/user/onboarding/form', payload);
